import $ from 'jquery';
import 'featherlight';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import './slick';
import '../css/jquery-ui.css';

export {
    readMoreEvents,
    initReadMoreEvents,
    moreMenu,
    toggleEvents,
    setUpSlick,
    teardownSlick,
    modalEvents,
    roomTextUpdate,
    redirectToCompanyLogin,
    convertHyperLink
};

$(function () {
    resetValEvents();
    password();
    // modalNumInput();
    roomText();
    tabEvents();
    // readMoreEvents(); TODO こっちで呼ぶとプラン一覧が壊れるので他画面は対応
    vacancyCalendarListEvents();
    // toggleEvents();  TODO こっちで呼ぶとプラン一覧が壊れるので他画面は対応
    modalEvents();
    pagetopEvents();
    calendarInputEvents();
    // redirectToCompanyLogin();
    anchorEvents();
});

// -----------------input 内容削除ボタン✕ ----------------- //
function resetValEvents() {
    $(".resetIcon").click(function () {
        $(this).next("input").val("");
    });
}

// -----------------こだわり条件もっと見るボタン ----------------- //
function moreMenu(context) {
    $('.grad_trigger', context).change(function () {
        let btnCheked = $('.grad_trigger', context).prop('checked');
        if (btnCheked) {
            $(this).next("form").find(".grad_item").addClass("check");
            $(this).next("form").find(".grad_item").removeClass("none");
        } else {
            $(this).next("form").find(".grad_item").removeClass("check");
        }
    });

    let len = $('.search_checkList > div', context).length;
    let a = 1;
    if (len <= a) {
        $(".grad_item", context).addClass("none");
    }
}

// -----------------パスワードの可視化 ----------------- //
function password() {
    $('.toggle-password').on('click', (function () {
        $(this).toggleClass("mdi-eye mdi-eye-off");
        var input = $(this).parent().prev("input");
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    }));
}

// ----------------- モーダルで選択した室数を反映 ----------------- //
function roomText() {
    $("#roomType").on("change", function () {
        let room = $("select[name=roomType]").val();
        $("#room_text , #room_text02").text(room);
    });
}

// ----------------- モーダルで選択した室数を明示的に反映 ----------------- //
function roomTextUpdate(number) {
    $("#room_text , #room_text02").text(number);
}

// ----------------- タブ ----------------- //
function tabEvents() {
    $('.switchNav a').on('click', function (e) {
        e.preventDefault();
        let target = $(this).attr('href');
        if (!$(target).length) return false;
        $('.switchLabel', $(this).closest('.switchNav')).removeClass('active');
        $(this).closest('.switchLabel').addClass('active');
        $('.switchItem', $(target).closest('.switchArea')).removeClass('active');
        $(target).addClass('active');
    });
}

// ----------------- 続きを見る ----------------- //
function initReadMoreEvents(context) {
    $('.read_close', context).each(function () {
        $(this).removeAttr('display');
        $(this).removeClass('readmore-initialized');
    });

    $('.moreTxt', context).each(function () {
        $('.switchItem').removeAttr('display');
        $('.switchItem').removeAttr('style');
        $(this).next('.moreBtn').removeAttr('display');
        $(this).removeAttr('style');
        $(this).removeClass('long');
        $(this).removeClass('readmore-initialized');
    });
}

function readMoreEvents(context) {
    $('.read_close', context).not('.readmore-initialized').each(function () {
        // $(this).css('display', 'none').addClass('readmore-initialized');
        $(this).css('display', 'none');
    });

    $('.moreTxt', context).not('.readmore-initialized').each(function () {
        $('.switchItem').css('display', 'block');
        var h = $(this).innerHeight();
        $('.switchItem').removeAttr('style');
        if (h < 60) {
            $(this).next('.moreBtn').css('display', 'none');
        } else {
            $(this).css('height', '54px');
            $(this).addClass('long');
            $(this).next('.moreBtn').css('display', 'block');
        }
        $(this).addClass('readmore-initialized');
    });

    $('.read_more', context).not('.readmore-initialized').on('click', (function (e) {
        e.preventDefault();
        $(this).css('display', 'none');
        let close = $(this).parents(".moreBtn").find('.read_close');
        close.css('display', 'inline');
        let text = $(this).closest('div').find('.moreTxt');
        text.css({
            display: "block",
            height: "auto"
        });
        text.removeClass('long');
        text.addClass('fullTxt');
        let defHeight = text.height();
        text.css('height', defHeight + 10 + 'px');
        $(this).addClass('readmore-initialized');
    }));

    $('.read_close', context).not('.readmore-initialized').on('click', (function (e) {
        e.preventDefault();
        $(this).css('display', 'none');
        let more = $(this).parents('.moreBtn').find('.read_more');
        more.css('display', 'inline');
        let text = $(this).closest('div').find('.moreTxt');
        text.css('height', '54px');
        text.addClass('long');
        text.removeClass('fullTxt');
        $(this).addClass('readmore-initialized');
    }));
}

// ----------------- カレンダー サイドリスト外観 ----------------- //
function vacancyCalendarListEvents() {
    $('.vacancy_sideList li').on('click', (function (e) {
        e.preventDefault();
        $('.vacancy_sideList li').removeClass('active');
        $(this).addClass('active');
    }));
}


// ----------------- 開閉ボタン ----------------- //
function toggleEvents(context) {
    $('.readMore', context).on('click', function (e) {
        e.preventDefault();
        $(this).next('.readMore_area').slideDown();
        $(this).css({
            'pointer-events': 'none',
            'opacity': '0'
        });
    });

    $('.readMore_close', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().prev('.readMore').slideDown().css({
            'pointer-events': 'auto',
            'opacity': '1'
        });
        $(this).parent('.readMore_area').slideUp();
    });

    $('.chooseBox_list_more.first', context).on('click', function () {
        $(this).next('.readMore_area').slideToggle('fast');
        $(this).css('display', 'none');
    });

    $('.chooseBox_list_more', context).on('click', function () {
        $(this).parent().next('.readMore_area').slideToggle('fast');
        $(this).css('display', 'none');
    });

    $('.chooseBox_list_close', context).on('click', function () {
        $(".readMore_area", context).slideToggle('fast');
        $(".chooseBox_list_more", context).css('display', 'block');
        let offset = $(this).parents(".itemWrap").offset().top;
        $(window).scrollTop(offset);
    });

    $('.openToggle', context).on('click', function () {
        $(this).toggleClass('active').next('.openToggleArea').slideToggle(300);
    });
}


// ----------------- 生年月日入力 ----------------- //
function inputDayEvents() {
    let time = new Date;
    let inputYear = time.getFullYear();
    for (let i = inputYear; i >= 1900; i--) {
        $('.inputYear').append('<option value="' + i + '">' + i + '</option>');
    }
    for (let i = 1; i <= 12; i++) {
        $('.inputMonth').append('<option value="' + i + '">' + i + '</option>');
    }
    for (let i = 1; i <= 31; i++) {
        $('.inputDay').append('<option value="' + i + '">' + i + '</option>');
    }
    for (let i = inputYear; i <= inputYear + 10; i++) {
        $('.inputCardYear').append('<option value="' + i + '">' + i + '</option>');
    }
}

// ----------------- モーダル ----------------- //
let modalCl = null;
let modalWidth = 0;
let modalHeight = 0;

function modalEvents(context) {
    const modalContext = context ? context : document;
    $('.modalLink', modalContext).on('click', (function (e) {
        e.preventDefault();
        $(this).blur();
        if ($('.modalBack')[0]) return false;
        let modalTarget = this.getAttribute("data-target");
        if (typeof (modalTarget) == "undefined" || !modalTarget || modalTarget == null) {
            return false;
        }
        $('html, body').css('overflow', 'hidden');
        modalCl = document.getElementById(modalTarget);
        let el = document.documentElement;
        let elbody = document.body;
        modalWidth = el.scrollLeft || elbody.scrollLeft;
        modalHeight = el.scrollTop || elbody.scrollTop;
        $('body').append('<div class="modalBack"></div>');
        $('.modalBack').fadeIn('fast');
        modalPosition();
        $(modalCl).fadeIn('fast');
        $('.modalBack, .modalWindow .close, .modalWindow .closeBtn').unbind().click(function (e) {
            e.preventDefault();
            $('body').removeAttr('style');
            window.scrollTo(modalWidth, modalHeight);
            $('.modalWindow, .modalBack').fadeOut('fast', function () {
                $('.modalBack').remove();
                $('html').removeAttr('style');
            });
        });
    }));
    $(window).resize(modalPosition);

    function modalPosition() {
        let w = $(window).width();
        let h = $(window).height();
        let cw = $(modalCl).outerWidth();
        let ch = $(modalCl).outerHeight();
        $(modalCl).css({
            "left": ((w - cw) / 2) + "px",
            "top": ((h - ch) / 2) + "px"
        })
    }
}

// ----------------- ページ上部へ戻る ----------------- //
function pagetopEvents() {
    const pagetopBtn = $('.pagetop');
    pagetopBtn.hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            pagetopBtn.fadeIn(200);
        } else {
            pagetopBtn.fadeOut(200);
        }
    });
    pagetopBtn.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 300);
        return false;
    });
}

// ----------------- カレンダーにスクロール ----------------- //
function anchorEvents() {
    const anchorBtn = $('.anchorButton');
    anchorBtn.click(function () {
        let anchor_position = $('.sectionText_box').position().top;
        $("html, body").animate({scrollTop: anchor_position}, 300, "swing");
        return false;
    });
}

// ----------------- チェックイン非活性 ----------------- //
//   日程入力
function calendarInputEvents() {
    $('input[name="undecided"]').change(function () {
        let elCheked = $('input[name="undecided"]').prop('checked');
        if (elCheked) {
            $('input[name="checkin"]').prop('disabled', true);
        } else {
            $('input[name="checkin"]').prop('disabled', false);
        }
    });
}


// ----------------- 同意チェックボタン ----------------- //

function termsCheck(check) {
    if (check.checked) {
        document.getElementById("termsCheck").style.display = "block";
        document.getElementById("no_termsCheck").style.display = "none";
    } else {
        document.getElementById("termsCheck").style.display = "none";
        document.getElementById("no_termsCheck").style.display = "block";
    }
}

// -------------- クレジットカード入力欄表示切替 --------------- //
function registCard() {
    document.getElementById("registCard").style.display = "block";
}

function registCard_non() {
    document.getElementById("registCard").style.display = "none";
}

//-- slickの初期設定
function setUpSlick(context) {
    const slickContext = context ? context : document;
    setSlickSliderEvents(slickContext);
    setSlickSliderEvents2(slickContext);
    setSlickSliderEvents3(slickContext);
    setSlickSliderEvents4(slickContext);
}

// 解除
function teardownSlick(context) {
    const slickContext = context ? context : document;
    $(".slider_modalArea .slider_inner", slickContext).filter('.slick-initialized').slick('unslick');
    $(".slider_area .slider_inner", slickContext).filter('.slick-initialized').slick('unslick');
    $(".slider_tabArea .slider_inner", slickContext).filter('.slick-initialized').slick('unslick');
    $(".slider_minImgArea .slider_inner", slickContext).filter('.slick-initialized').slick('unslick');
}

function setSlickSliderEvents(context) {
    let modalSlider = $(".slider_modalArea .slider_inner", context).not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });

    $('.modalLink', context).click(function () {
        modalSlider.slick('setPosition');
        modalSlider.slick('slickPlay');
        $('.modalBack, .modalWindow .close, .modalWindow .closeBtn', context).click(function () {
            modalSlider.slick('slickPause');
            modalSlider.slick('slickGoTo', 0);
        });
    });
}

function setSlickSliderEvents2(context) {
    $(".slider_area .slider_inner", context).not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        dots: true
    });
}

function setSlickSliderEvents3(context) {
    let tabSlider = $(".slider_tabArea .slider_inner", context).not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        dots: true
    });
    tabSlider.slick('setPosition');
    $('.switchLabel', context).click(function () {
        tabSlider.slick('setPosition');
    });
}

function setSlickSliderEvents4(context) {
    $(".slider_minImgArea .slider_inner", context).not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}
function getUrlParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function redirectToCompanyLogin(contextPath) {
    let url = contextPath + "/GCER004F03500/GCER004A01";
    let form = $('<form />', {action: url, method: "post", style: "display:none;"}).appendTo('body');
    form.append('<input type="hidden" name="hotelCode" value="' + getUrlParam('hotelCode') + '" />');
    form.submit();
}

/*
 * 文字列からリンクを抜き出してハイパーリンク化する
 * v-HTMLでの出力を想定しているため、HTMLエンコードも独自に掛ける
 */
function convertHyperLink(originText) {
    // "http://"で始まり空白（改行含む）までで終わる文字列を検索する正規表現
    const URL_REGEXP = /(https?:\/\/[^\s]+)/ig;
    // HTMLエスケープ処理
    const escapeHtml = targetText => targetText
        .replaceAll('&', '&amp;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    const originTextNotNull = originText || "";

    return originTextNotNull.split(URL_REGEXP)
        .map((maybeLinkText, index) => {
            const maybeLinkTextEscaped = escapeHtml(maybeLinkText);
            //リンク文字列で区切っているので必ず奇数番目はリンク文字列ではない
            if (index % 2 == 0) {
                return maybeLinkTextEscaped;
            }
            return `<a href='${maybeLinkTextEscaped}' target='_blank'>${maybeLinkTextEscaped}</a>`;
        })
        .join('');
}
